import { useState } from "react";
import { Box, Typography } from "@mui/material";
import OutOff from "../../assets/icon/out-off.png";
import OutOn from "../../assets/icon/out-on.png";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../../redux/slices/auth/logOutSlince.js";
import NotificationIcon from "../notifications/NotificationIcon";

export default function LogoutButton({ setUser, role }) {

  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const [logout] = useLogoutMutation();

  const handleLogout = async (e) => {
    try {
      await logout().unwrap();  
      console.log("Logout API success");
    } catch (err) {
      console.error("Logout API error:", err);
    } finally {
      localStorage.removeItem("token");
      setUser(null);
      navigate("/login", { replace: true });
    }
  };



  return (
    <Box
      className="logout-wrapper"
      style={{ display: "flex", alignItems: "center", marginLeft: "15px" }}
    >
      {role === 'admin' && <NotificationIcon />}
      <Box
        onClick={handleLogout}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        <img
          draggable={false}
          src={hover ? OutOn : OutOff}
          alt="logout"
          className="logout-icon"
        />
        <Typography
          style={{
            color: hover ? "#3B7DDD" : "#495057",
            fontWeight: "bold",
            fontSize: "14px",
            marginLeft: "5px"
          }}
        >
          Hesabdan çıxış
        </Typography>
      </Box>
    </Box>
  );
}
